<template>
  <h1 class="title has-text-centered">
    <go-to-dashboard-button />

    {{ $t("productCreation.title") }}&nbsp;&nbsp;&nbsp;&nbsp;

    <hr />
  </h1>
</template>

<script>
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  components: {
    goToDashboardButton
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
